import React, { useEffect, useState } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, SubmitHandler } from 'react-hook-form'
import { errorToast, successToast } from 'src/utils/toastService'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'src/store'
import { startPageLoader, stopPageLoader } from 'src/store/features/common/commonSlice'
import { IFormInput, formSchema } from '../UploadExerciseModal/useUploadExercise'
import {
  useGetAITrainerExerciseDetailsByIdQuery,
  useUpdateAITrainerMutation,
} from 'src/api/aiTrainerApi'

type useEditAITrainerProps = {
  successCallback: () => void
  id: number
}
const useEditAITrainer = ({ successCallback, id }: useEditAITrainerProps) => {
  const [file, setFile] = useState<File | null>(null)

  const [videoUrl, setvideoUrl] = useState<string>('')

  const [showUploadImage, setShowUploadImage] = useState(false)
  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(formSchema),
    mode: 'all',
    defaultValues: {
      name: '',
      equipmentNeeded: '',
      time: 0,
      trainingLevel: '',
      instruction: '',
    },
  })

  const { data, isFetching, refetch } = useGetAITrainerExerciseDetailsByIdQuery(id)

  const [updateAITrainer, { isLoading: isLoadingEditAITrainer }] = useUpdateAITrainerMutation()
  const dispatch = useDispatch<AppDispatch>()

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.length) {
      setFile(e.target.files[0])
    }
  }

  const onSubmit: SubmitHandler<IFormInput> = (data) => {
    console.log(data, file)
    const formData = new FormData()
    formData.append('name', data.name)
    formData.append('equipment_needed', data.equipmentNeeded)
    formData.append('time', data.time.toString())
    formData.append('training_level', data.trainingLevel)
    formData.append('instruction', data.instruction)
    if (file) {
      formData.append('video', file)
    }
    updateAITrainer({
      id,
      data: formData,
    })
      .unwrap()
      .then((res: any) => {
        console.log(res)
        successToast('Excecise updated successfully.')
        reset()
        setFile(null)
        successCallback()
      })
      .catch((err: any) => {
        console.log(err)
        errorToast('Unable to updated the exercise.')
      })
  }
  useEffect(() => {
    if (isFetching) {
      dispatch(startPageLoader())
    } else {
      dispatch(stopPageLoader())
    }
  }, [isFetching])

  useEffect(() => {
    if (data) {
      setValue('name', data.name)
      setValue('equipmentNeeded', data.equipment_needed)
      setValue('time', data.time)
      setValue('trainingLevel', data.training_level)
      setValue('instruction', data.instruction)
      if (data.video) {
        setvideoUrl(data.video)
      }
    }
  }, [data])

  return {
    file,
    handleFileChange,
    onSubmit: handleSubmit(onSubmit),
    control,
    errors,
    isLoadingEditAITrainer,
    videoUrl,
    showUploadImage,
    handleShowUploadImage: () => setShowUploadImage(true),
  }
}

export default useEditAITrainer
